export default __webpack_public_path__ + "static/media/ketodrink-wide@2x.9c237933.jpg";